<template lang="pug">
	tr.crop__row( :data-level="rowLevel")
		table.crop__inner
			tr.crop__row_inner
			
				crop-cell( 
					v-for="(period, i) in periods"
					v-bind:type="'prim'"
					v-bind:oneCrop="oneCrop"
					v-bind:rowLevel="rowLevel"
					v-bind:horPos="horPos"
					v-bind:period="period"
					v-bind:periods="periods"
					v-on:white-field="createWhiteField"
					:key="i"
					:class="{white: white && fhp(period.id) == start || white && end > fhp(period.id) && fhp(period.id) > start}"
					
				)
			tr.crop__row_inner.secondary
				
				crop-cell( 
					v-for="(period, i) in periods"
					v-bind:type="'sec'"
					v-bind:oneCrop="oneCrop"
					v-bind:rowLevel="rowLevel"
					v-bind:horPos="horPos"
					v-bind:period="period"
					v-bind:periods="periods"
			
					v-on:white-field="createWhiteField"
					:key="i"
					:class="{white: white && fhp(period.id) == start || white && end > fhp(period.id) && fhp(period.id) > start }"
				)
				
		
							
				
		
				
</template>

<script>

	import Cell from '@/blocks/includes/cropCell.vue';

	export default {
		name: 'Row',
		data: function(){
			return {
				white: false, 
				start: null,
				end: null
			}
		},
		props: {
			rows: Array,
			periods: Array,
			period: Object,
			oneCrop: Array,
			horPos: Array,
			rowLevel: Number
		},
		methods: {
			createWhiteField(ob) {
				this.white = ob.white
				// this.periodId = ob.periodId
				if(ob.start) this.start = ob.start;
				if(ob.end) this.end = ob.end;
			

				
				
			},
			fhp(id) {
				return this.horPos.indexOf(id);
			},
			fixHeight() {
				let tr = document.querySelectorAll('.crop__row_inner');
				let block = document.querySelectorAll('.cell__block');
				for(var i = 0; i < tr.length; i++) {
					let ar = [];
					let els = []
					for(var j = 0; j < block.length; j++) {
						if((block[j].getBoundingClientRect().top - tr[i].getBoundingClientRect().top) > -1 && (block[j].getBoundingClientRect().top - tr[i].getBoundingClientRect().top) < 40 ) {
							ar.push(block[j].clientHeight);
							els.push(block[j]);
							els.forEach(item => {
								item.style.height = Math.max.apply(null, ar) + 'px';
								// if(item.children[0].classList.contains('cell__plus')) {
								// 	item.children[0].style.height = Math.max.apply(null, ar) + 'px';
								// }
							})
						}
					}
				}

			
			
				
			}
		
		},
		components: {
			'crop-cell': Cell
		},
		mounted() {
			setTimeout(this.fixHeight);
		}
		
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';

	// .white {
	// 	position: relative;

	// 	&:before {
	// 		position: absolute;
	// 		content: '';
	// 		top: 0;
	// 		left: 0;
	// 		width: 100%;
	// 		height: 100%;
	// 		background-color: #fff;
	// 		z-index: -1;
	// 	}
	// }


</style>